module.exports = __webpack_public_path__ + "img/banner_mail.06704b55.svg";